module.exports = __webpack_public_path__ + "media/images/homes/Color-CodedDisplay-3104f120fc62f669c954ae33d0773a15.png";